import { createContext } from 'react'

// Ids the panel needs to name itself (aria-labelledby / aria-describedby). The
// title and description register themselves so the panel only points at ids
// that exist.
export interface DialogA11y {
  titleId: string
  descriptionId: string
  hasTitle: boolean
  hasDescription: boolean
  setHasTitle: (v: boolean) => void
  setHasDescription: (v: boolean) => void
}

export const DialogA11yContext = createContext<DialogA11y | null>(null)
